export default function MovingLocator(props) {
    const { what } = props;
  
    return (
      <div
        className="locator"
        style={{
          display: what[0] ? 'block' : 'none',
          top: `${what[1]}px`,
          left: `${what[2]}px`,
          width: `${what[3]}px`,
        }}
      >
      </div>
    );
  }